/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ChevronRight } from 'Icons';
import React from 'react';
import styles from './expandable-section.module.css';

interface ExpandableSectionProperties {
    title: React.ReactNode;
    children: React.ReactNode;
    expanded?: boolean;
}

function ExpandableSection({
    title,
    children,
    expanded = false,
}: ExpandableSectionProperties): React.ReactElement<ExpandableSectionProperties> {
    const [active, setActive] = React.useState<boolean>(expanded);
    const contentRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        if (contentRef.current) {
            contentRef.current.style.height = active ? `${contentRef.current.scrollHeight}px` : '0px';
        }
    }, [active]);

    return (
        <>
            <div className={`${styles.ExpandableSection}`} aria-expanded={active} onClick={() => setActive(!active)}>
                {title}
                <div className={`${styles.icon} ${active ? styles.iconRotate : ''}`}>
                    <ChevronRight />
                </div>
            </div>
            <div
                ref={contentRef}
                className={`${styles.ExpandableSectionChildren} ${active ? styles.ExpandableSectionChildrenExpanded : ''}`}
            >
                {children}
            </div>
        </>
    );
}

export default ExpandableSection;
